import React from 'react';
import PropTypes from 'prop-types';

import {
  audiences,
  audienceTitles,
} from 'inside-out/managers/resourceLibraryManager';

import {
  wrapperStyle,
  itemStyle,
} from './styles';

import AudienceIcon from 'inside-out/components/shared/icons/audienceIcon';

const audiencesData = [ '', ...audiences ].map(audience => {
  const a = {
    id: audience,
    title: audienceTitles[audience] || 'All Resources',
  };
  return {
    ...a,
    icon: <AudienceIcon audience={a} size={12} />,
  };
});

export function AudienceFilter({ activeAudience, onChange }) {
  function onClick(id) {
    return function(e) {
      e.preventDefault();
      onChange(id);
    }
  }
  return (
    <div className={wrapperStyle}>
      {audiencesData.map(audience => (
        <div key={audience.id} onClick={onClick(audience.id)} className={itemStyle(audience.id === activeAudience)}>
          {audience.icon}
          <span>{audience.title}</span>
        </div>
      ))}
    </div>
  );
};

AudienceFilter.propTypes = {
  activeAudience: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/resource-library/audienceFilter/component.js